import { NgControl} from '@angular/forms';
import {Directive, Input} from '@angular/core';

@Directive({
  selector: '[appDisableControlForm]'
})
export class DisableControlFormDirective {
  @Input() set disableControl (condition: Boolean){
    const action = condition ? 'disable' : 'enable';
    this.ngControl.control[action]();
  };

  constructor( private ngControl: NgControl ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/directives/disable-control-form/disable-control-form.directive.ts